export enum AttendedLobbies {
    Any = 186,
    DoormanFullTime = 3842,
    DoormanPartTime = 3843,
    Concierge = 187,
    ElevatorMan = 189
}